// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V21H23V3ZM7 8H11V10H7V14H11V16H7C5.89543 16 5 15.1046 5 14V10C5 8.89543 5.89543 8 7 8ZM15 8H19V10H15V14H19V16H15C13.8954 16 13 15.1046 13 14V10C13 8.89543 13.8954 8 15 8Z"}}]};

const SubtitleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'subtitle-filled',
    ref,
    icon: element,
  },
));

SubtitleFilledIcon.displayName = 'SubtitleFilledIcon';

export default SubtitleFilledIcon;
